
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/minha-casa-minha-vida",
      function () {
        return require("private-next-pages/minha-casa-minha-vida/index.js");
      }
    ]);
  